export default "__VITE_ASSET__DPCaXffX__"